import type { Due } from '@/entities/shared/due/due';
import { dueState } from '@/entities/shared/due/due-state';
import { REMIND_DAYS } from '@/entities/shared/due/remind-days';
import { daysBetween } from '@/shared/lib/dates/days-between';
import type { IsoDate } from '@/shared/lib/dates/iso-date';
import { today } from '@/shared/lib/dates/today';
import type { ShoppingItem } from '../schemas/shopping-item';

/** A pending entry with `needed_by`: amber 3 days before, red once past. */
export function neededDue(entry: ShoppingItem, on: IsoDate = today()): Due | null {
  if (entry.status !== 'pending' || !entry.needed_by) return null;
  const days = daysBetween(on, entry.needed_by);
  return { date: entry.needed_by, kind: 'needed', days, urgency: dueState(days, REMIND_DAYS.needed) };
}
